import requestor from "requestor";
import React, {useEffect} from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {push} from "react-router-redux";

import CircularProgress from "@material-ui/core/CircularProgress";

import Permissioner from "utils/permissioner";
import {isInitialised} from "utils/uninitialised";
import setTitle from "utils/set_title";
import TestsComponent from "../components/tests";

import {RouterState, InjectedRouter} from "react-router/lib/Router";
import {Organisation} from "common/types/organisation";
import {User} from "common/types/user";
import {AggregatedWorkflowTest} from "common/flowmaster/types/test";
import getNewSearchParams from "routes/llm_run/utils/filtering/update_url_params";
import {getLlmRunQueryParams} from "routes/llm_run/utils/filtering/get_llm_run_query_params";
import pickLlmRunFiltersFromURL from "routes/llm_run/utils/filtering/pick_llm_run_filters_from_url";
import llmRunWorkflowTestsFetchAction from "modules/flowmaster/actions/workflow_tests_fetch";

interface Props {
  user: User;
  router: RouterState & InjectedRouter;
  location: Location;
  params: {
    organisationId: string;
  };
  dispatch: (args: unknown) => unknown;
  organisation: Organisation;

  workflowTests: AggregatedWorkflowTest[];
  addTestSetAction: (organisationId: number, name: string) => void;
}
function TestsContainer({user, router, workflowTests, dispatch}: Props) {
  const llmRunValues = getLlmRunQueryParams(pickLlmRunFiltersFromURL(router));
  const organisationId = parseInt(router.params.organisationId, 10);

  useEffect(() => {
    fetchWorkflowTests(organisationId, llmRunValues);
  }, [organisationId, JSON.stringify(llmRunValues)]);
  const permissioner = new Permissioner(user);
  if (
    !(permissioner.hasPermission("get-workflows") || permissioner.isAdmin())
  ) {
    return permissioner.getNoPermissionMessage();
  }

  setTitle("LLM Run Scores");

  const shouldRenderContainer = isInitialised([user, workflowTests]);
  if (!shouldRenderContainer || !user.permissions) {
    return (
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  const updateUrlParams = obj => {
    const {pathname, search} = location;
    const newSearch = getNewSearchParams(obj, search);
    if (search !== newSearch) {
      dispatch(push(pathname + newSearch));
    }
  };

  function fetchWorkflowTests(organisationId, query) {
    dispatch(llmRunWorkflowTestsFetchAction(requestor)(organisationId, query));
  }

  return (
    <TestsComponent
      organisationId={organisationId}
      workflowTests={workflowTests}
      filters={llmRunValues}
      updateValue={obj => {
        updateUrlParams(obj);
      }}
    />
  );
}

function select(state) {
  return {
    user: state.user,
    organisation: state.organisation,
    workflowTests: state.workflowTests,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators({}, dispatch),
  };
}

export default connect(select, mapDispatchToProps)(TestsContainer);
